import emptyContent from "../../../assets/emptyContent.png";

const EmptyContentList = () => {
  return (
    <>
      <div>
        <div className="flex flex-col items-start md:flex-row md:justify-stretch md:items-start md:flex-wrap md:w-[100%]">
          <img className="pt-7 pr-7" src={emptyContent} alt="Empty content" />
          <img className="pt-7 " src={emptyContent} alt="Empty content" />
          <img className="py-7 pr-7" src={emptyContent} alt="Empty content" />
          <img className="py-7 " src={emptyContent} alt="Empty content" />
        </div>
      </div>
      <h5 className="text-center text-base leading-[26px]">
        Якщо сторінка довго не завантажується, будь ласка, повідомте про це.
        <br />
        <a
          className="text-hover_text"
          href="mailto:radio-silpo@fozzy.ua?subject=Відгук зі сторінки контактів"
        >
          radio-silpo@fozzy.ua
        </a>
      </h5>
    </>
  );
};

export default EmptyContentList;
